import { Toaster } from 'sonner'
import { useThemeContext } from '@/ui/theme/theme-provider'

const borda = (cor: string) =>
  `!border-l-4 !border-l-[var(--mui-palette-${cor}-main)] [&_svg]:!text-[var(--mui-palette-${cor}-dark)]`

/** O aviso rápido do teles: cinza claro, borda colorida à esquerda por tipo. */
export function AppToaster() {
  const { isDarkMode } = useThemeContext()
  return (
    <Toaster
      position="top-center"
      closeButton={false}
      theme={isDarkMode ? 'dark' : 'light'}
      offset={10}
      toastOptions={{
        style: {
          background: 'hsl(var(--grey-50))',
          color: 'var(--mui-palette-text-primary)',
          border: '1px solid var(--mui-palette-divider)',
          padding: '10px 16px',
          fontSize: '0.8125rem',
          borderRadius: '12px',
        },
        classNames: {
          success: borda('success'),
          error: borda('error'),
          warning: borda('warning'),
          info: borda('info'),
        },
      }}
    />
  )
}
